import { render, staticRenderFns } from "./ChooseRole.vue?vue&type=template&id=22d8e7cf&scoped=true"
import script from "./ChooseRole.vue?vue&type=script&lang=js"
export * from "./ChooseRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d8e7cf",
  null
  
)

export default component.exports